// ABOUTME: Utility functions for quantity display and numeric extraction.
// Operates on the QuantitySelection discriminated union from tuc-processes.

import {QuantitySelection} from '@hconnect/tuc-processes/fields/quantity/types'

/**
 * Formats a QuantitySelection for display in the UI.
 *
 * - Quantity mode: "8 m³"
 * - FullLoads mode: "2 full loads: 10-15 m³" or "2 full loads: m³" if min/max unavailable
 *
 * @param quantity - The QuantitySelection to format
 * @param t - i18n translation function
 */
export const formatQuantityDisplay = (
  quantity: QuantitySelection,
  t: (key: string, defaultValue: string, options?: Record<string, unknown>) => string
): string => {
  if (quantity.type === 'volume') {
    return `${quantity.volume} ${quantity.quantityUom}`
  }

  const {fullLoads, minQuantity, maxQuantity, quantityUom} = quantity
  return t(
    'orderIntake.rmc.quantity.fullLoadsWithRange',
    '{{count}} full loads: {{min}}-{{max}} {{uom}}',
    {count: fullLoads, min: minQuantity, max: maxQuantity, uom: quantityUom}
  )
}
